package com.milta.core.localization.translations.de

import com.milta.core.localization.SettingsStrings

// MIL-53 — genuinely translated (unlike the rest of this `de` package, see De.kt remarks).
internal val Settings = SettingsStrings(
    profileSectionTitle = "ORGANISATIONSPROFIL",
    profileNameLabel = "Name der Organisation",
    languageSectionTitle = "OBERFLÄCHENSPRACHE",
    languageSearchPlaceholder = "Sprache suchen...",
    languageMoreAvailable = "%d weitere Sprachen verfügbar",
    languageErrorGeneric = "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    subscriptionSectionTitle = "ABONNEMENT",
    subscriptionPlanLabel = "Tarif",
    subscriptionBillingLabel = "Abrechnung",
    subscriptionRenewalLabel = "Nächste Verlängerung",
    subscriptionBillingMonthly = "Monatlich",
    subscriptionBillingAnnual = "Jährlich",
    subscriptionPlanOrganisationLabel = "Organisation (Leitung + Team)",
    subscriptionPriceSuffix = "zzgl. MwSt. / Monat",
    subscriptionUnavailable = "Nicht verfügbar",
    deleteSectionTitle = "Organisation löschen",
    deleteWarning = "Diese Aktion ist endgültig und unwiderruflich.",
    deleteDescription = "Touren und Zustellnachweise werden gelöscht. Fahrerkonten werden von der Organisation getrennt, aber niemals gelöscht.",
    deleteConfirmLabel = "Geben Sie zur Bestätigung den Namen der Organisation ein",
    deleteButton = "Endgültig löschen",
    deleteFinalDialogTitle = "Endgültige Löschung bestätigen?",
    deleteFinalDialogMessage = "Diese Aktion kann nicht rückgängig gemacht werden. Die Organisation, ihre Touren und Zustellnachweise werden endgültig gelöscht.",
    deleteErrorGeneric = "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    legalSectionTitle = "RECHTLICHE HINWEISE",
    legalTermsLabel = "Nutzungsbedingungen",
    legalPrivacyLabel = "Datenschutz & DSGVO",
)
